import {z} from 'zod'
import {StripeProductId} from './StripeProductId.js'
import {StripeSubscriptionId} from './StripeSubscriptionId.js'

export const StripeSubscription = z.object({
  subscriptionId: StripeSubscriptionId,
  productId: StripeProductId,
  validUntilDate: z.iso.datetime(),
  canceled: z.boolean(),
  trial: z.boolean(),
})
export type StripeSubscription = z.infer<typeof StripeSubscription>
